export interface PlaceSummary {
  id: string;
  name: string;
  subtitle?: string;
}

export interface WorkspaceContextValue {
  places: PlaceSummary[];
  activePlace: PlaceSummary | null;
  setActivePlace: (placeId: string) => void;
  isReady: boolean;
}

export const ACTIVE_PLACE_STORAGE_KEY = 'zr.activePlaceId';
